module.exports = __webpack_public_path__ + "img/bg_tailor_shop.a08d93e5.jpg";